module.exports = __webpack_public_path__ + "media/img/uploads/logo-pm-mission-command-1c7a56c3695652006535cde98403a221.png";